import React, { useState, useEffect } from 'react';
import axios from "../../common/axios";
import { Alert } from 'antd';
import CircularLoader from '../../common/CircularLoader';
import Test from "../../tests/student/assessments/Test";
import TestResult from "../../tests/student/assessments/TestResult";

const TestActivityResult = ({ step, pathwayUser, continueCurrentStep }) => {
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [testAssignment, setTestAssignment] = useState(null);
    const [testResult, setTestResult] = useState(null);

    useEffect(() => {
        if (!pathwayUser || !step) {
            setTestAssignment(null);
            setTestResult(null);
            setError(null);
            setLoading(false);
            return;
        }

        const fetchTestResultData = async () => {
            try {
                setLoading(true);
                const response = await axios.get('/web/ui/test/trail/testResults', {
                    params: {
                        pathwayUserId: pathwayUser.pathwayUserId,
                        stepId: step.stepId
                    }
                });

                setTestAssignment(response.data.testAssignment);
                setTestResult(response.data.testResult);
            } catch (err) {
                console.error('Failed to load test results:', err);
                setError("Unable to load test results.");
                setTestAssignment(null);
            } finally {
                setLoading(false);
            }
        };

        fetchTestResultData();
    }, [pathwayUser, step]);

    if (isLoading || !pathwayUser || !step) {
        return <CircularLoader />;
    }

    if (error) {
        return (
            <Alert
                type="error"
                showIcon
                message="Error"
                description={error}
            />
        );
    }

    if (!testAssignment || !testResult) {
        return (
            <Alert
                type="error"
                showIcon
                message="Test Result Not Found"
                description="No test result was returned by the server."
            />
        );
    }

    return (
        <div className="ch-trail-test">
            <TestResult
                testResultId={testResult.testResultId}
                showUserAnswers={true}
            />
        </div>
    );
};

export default TestActivityResult;